





























import { Component, Watch } from 'vue-property-decorator';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwSlider } from '@libs-uuif/shared/sw-slider';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { UnifiedInsightsReportsStoreState } from './unified-insights-reports.store';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';

const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

const cssPrefix = 'report-type-filter';

interface FilterOptions {
  label: string;
  id: string;
  statusFlag?: string;
  valueKey: string;
}
@Component({
  components: {
    SwCheckbox,
    SwIcon,
    SwSlider,
  },
})
export default class ReportTypeFilter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.Mutation
  saveToFilters: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['filterData']
  >;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  optionsSelected: string[] = [];

  reportTypeOptions: FilterOptions[] = [
    {
      label: this.$t('spog.unifiedInsights.onDemand')
      .toString(),
      id: 'OnDemand',
      statusFlag: 'onDemand',
      valueKey: 'onDemand',
    },
    {
      label: this.$t('spog.unifiedInsights.scheduled')
      .toString(),
      id: 'Scheduled',
      statusFlag: 'scheduled',
      valueKey: 'scheduled',
    },
  ];

  /*
    @desc returns selected options for Report Status filter.
  */
  get reportTypeFilter() {
    return this.filterData ? this.filterData.reportType : [];
  }

  @Watch('reportTypeFilter')
  onPropertyChanged(value: string[]) {
    this.optionsSelected = value;
  }

  /*
    @desc updates selected checkbox options.
  */
  updateSelected(event: any) {
    this.optionsSelected = event;
    const obj: any = {
      reportType: this.optionsSelected,
    };
    this.saveToFilters(obj);
  }

  created() {
    this.optionsSelected = this.reportTypeFilter;
  }
}
